import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { ProductImage } from "./ProductImage";
import { starProduct } from "../data/mock";

export const StarProductSection = () => {
  const navigate = useNavigate();
  const IconComponent = starProduct.Icon;

  return (
    <section
      id="star-product"
      className="py-24 bg-gradient-to-b from-[#f8fafc] to-white border-y border-[#e2e8f0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#ff9900]/10 border border-[#ff9900]/25 px-4 py-2 mb-6">
              <Sparkles className="w-4 h-4 text-[#ff9900]" />
              <span className="text-[#0a2a43] text-sm font-semibold">
                {starProduct.badge}
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mb-4 leading-tight">
              {starProduct.title}
            </h2>
            <p className="text-lg text-[#ff9900] font-medium mb-4">
              {starProduct.highlight}
            </p>
            <p className="text-[#4a6680] text-lg leading-relaxed mb-8">
              {starProduct.description}
            </p>
            <ul className="space-y-3 mb-10">
              {starProduct.features.map((line) => (
                <li
                  key={line}
                  className="flex items-start gap-3 text-[#4a6680]"
                >
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#ff9900] flex-shrink-0" />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
            <Button
              onClick={() => navigate(starProduct.ctaLink)}
              className="bg-[#0a2a43] hover:bg-[#0d3a5c] text-white font-semibold px-8 py-6 text-base rounded-xl shadow-lg shadow-[#0a2a43]/15 hover:shadow-xl transition-all duration-300"
            >
              {starProduct.ctaText}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="absolute -inset-4 bg-[#ff9900]/10 rounded-3xl blur-2xl opacity-70" />
            <div className="relative rounded-2xl border border-[#e2e8f0] bg-white shadow-xl shadow-[#0a2a43]/5 overflow-hidden">
              <div className="relative aspect-[4/3] bg-[#f1f5f9]">
                <ProductImage
                  publicId={starProduct.image}
                  alt={starProduct.title}
                  className="w-full h-full"
                />
                <div className="absolute top-4 left-4 w-12 h-12 rounded-xl bg-[#ff9900] flex items-center justify-center shadow-lg">
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
